import { DateTime } from 'luxon';

setInterval(() => {
    document.querySelectorAll<HTMLElement>('[data-relative-to-datetime]').forEach($ => {
        const attr = $.getAttribute('data-relative-to-datetime');
        if (!attr) {
            return;
        }

        const datetime = DateTime.fromISO(attr);
        $.textContent = datetime.toRelative();
    });
}, 10_000);